import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { API } from "../../lib/vikas";
import { beacon, opened1 } from "../../lib/beacon";

// the four private topics: drawn only as the private view's frames, never from the data file
export const PRIVATE_FRAMES = new Set(["ACCOUNTS", "GST", "VISION2075", "TRUST"]);
const FOUR = ["ACCOUNTS", "GST", "VISION2075", "TRUST"];
const ORIGIN = "https://vikas-private-view.saket-958.workers.dev";
const ACTIONS = new Set(["close", "new date", "note"]);
const TARGET = /^(ACC-\d+|GST-GSTC-\d+|V75-OI-\d+|TRU-(COLLECTION|VERIFICATION|INSURANCE)-[A-Z]+\d+[a-z]?)$/;

function Frame({ topic, theme, shown, height, frameRef }) {
  const [src, setSrc] = useState("");
  useEffect(() => {
    if (!src) return undefined;
    const t = setTimeout(() => { if (!height) beacon("frame_fail", topic, { reason: "no_height" }); }, 10000);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src, topic, height > 0]);
  useEffect(() => {
    let live = true;
    setSrc("");
    axios.get(`${API}/private-pass`, { params: { topic } })
      .then((r) => { if (live && r.data.ready) setSrc(`${r.data.src}&theme=${theme === "light" ? "light" : "dark"}`); })
      .catch(() => {});
    return () => { live = false; };
  }, [topic, theme]);
  if (!src) return null;
  return (
    <iframe ref={frameRef} src={src} title={`Private view ${topic}`} referrerPolicy="no-referrer" scrolling="no"
      className="pframe-if" style={{ display: shown ? "block" : "none", height: height ? `${height}px` : undefined }}
      onError={() => beacon("frame_fail", topic, { reason: "error" })}
      data-testid={`private-frame-${topic}`} />
  );
}

export function PrivateTabs({ theme, act, want }) {
  const tabs = FOUR;
  const [on, setOn] = useState(want || tabs[0]);
  const box = useRef(null);
  useEffect(() => {
    if (!want) return;
    setOn(want);
    box.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [want]);
  const [heights, setHeights] = useState({});
  const refs = useRef({});
  const actRef = useRef(act);
  actRef.current = act;

  useEffect(() => {
    const onMsg = (e) => {
      if (e.origin !== ORIGIN) return;
      const topic = FOUR.find((k) => refs.current[k] && refs.current[k].contentWindow === e.source);
      const m = e.data;
      if (!topic || !m || typeof m !== "object") return;
      if (m.kind === "vikas-height") {
        const px = Number(m.px);
        if (Number.isFinite(px) && px > 0) { opened1(topic); setHeights((h) => ({ ...h, [topic]: Math.min(Math.round(px), 100000) })); }
      } else if (m.kind === "vikas-press") {
        const action = String(m.action || "");
        const target = String(m.target_id || "");
        const ptopic = String(m.topic || "");
        if (!FOUR.includes(ptopic) || !ACTIONS.has(action) || !TARGET.test(target)) {
          if (FOUR.includes(ptopic) && ACTIONS.has(action)) beacon("refused", ptopic, { reason: "bad_target", action: action.replace(/\s+/g, "_") });
          return;
        }
        actRef.current(ptopic, action, target, typeof m.value === "string" ? m.value : "");
      }
    };
    window.addEventListener("message", onMsg);
    return () => window.removeEventListener("message", onMsg);
  }, []);

  return (
    <section className="pframe" data-testid="private-tabs" ref={box}>
      <div className="sec-h"><h2 data-testid="private-tabs-title">Private topics</h2></div>
      <div className="ptabs-row" role="tablist">
        {tabs.map((k) => (
          <button key={k} role="tab" aria-selected={on === k} className={`ptab${on === k ? " on" : ""}`}
            onClick={() => setOn(k)} data-testid={`private-tab-${k}`}>{k}</button>
        ))}
      </div>
      {tabs.map((k) => (
        <Frame key={k} topic={k} theme={theme} shown={on === k} height={heights[k]}
          frameRef={(el) => { refs.current[k] = el; }} />
      ))}
    </section>
  );
}
